import type { RouteRecordRaw } from "vue-router";
import { appRoutes } from "./apps";

export const menuRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter",
		name: "DesktopCenter",
		meta: {
			title: "桌面中心",
			icon: "zxg-home",
			keepAlive: false,
		},
		component: () => import("@main/views/DesktopCenter/DesktopCenter.vue"),
		children: [...appRoutes],
	},
	{
		path: "/appCenter",
		name: "AppCenter",
		meta: {
			title: "应用中心",
			icon: "zxg-category",
		},
		component: () => import("@main/views/AppCenter/AppCenter.vue"),
	},
	{
		path: "/marketingCenter",
		name: "MarketingCenter",
		meta: {
			title: "营销中心",
			icon: "zxg-marketing",
		},
		component: () => import("@main/views/MarketingCenter/MarketingCenter.vue"),
	},
	{
		path: "/serviceCenter",
		name: "ServiceCenter",
		meta: {
			title: "服务中心",
			icon: "zxg-serve",
		},
		component: () => import("@main/views/ServiceCenter/ServiceCenter.vue"),
	},
	{
		path: "/devCenter",
		name: "DevCenter",
		meta: {
			title: "研发中心",
			icon: "zxg-development",
		},
		component: () => import("@main/views/DevCenter/DevCenter.vue"),
	},
];
